// phpcs:ignoreFile
/* eslint-disable */
$(document)
    .ready(function () {
        if (typeof $.support.leadingWhitespace !== 'undefined' && !$.support.leadingWhitespace) {
            // IE8 and below. features not supported.
            $('#load').fadeOut().remove();
        } else {
            $('#load').fadeOut().remove();

            $('.dropdown-menu input, .dropdown-menu label').click(function (e) {
                e.stopPropagation();
            });

            // Todo: Remove on 03/01/2021
            // $('input, textarea').placeholder();

            // Start TouchSpin function
            $('input.qty').TouchSpin();

        }
    })
    .on('click', '.navbar-toggle', function () {
        // toggle navigation
        $('.navbar-collapse').toggleClass('in');
    })
    .on('click', '.navbar-collapse.in', function (e) {
        // close navigation on click
        if ($(e.target).is('a')) {
            $('.navbar-collapse').toggleClass('in');
        }
    });

$(window).resize(function () {
    if ($(window).width() > 768) {
        $('.collapse').removeClass('in');
    }
});

// adds sup to all superscript characters
$('body :not(script)')
    .contents()
    .filter(function () {
        return this.nodeType === 3;
    })
    .replaceWith(function () {
        return this.nodeValue.replace(/[™®]/g, '<sup>$&</sup>');
    });

$('.collapse').on('show.bs.collapse', function (e) {
    var $this = $(this);
    var id = $this.attr('id');

    if ($this.parents().hasClass('menu-collapse')) {
        $('.menu-collapse')
            .find('.collapse')
            .each(function () {
                var temp = $(this).attr('id');

                if (id != temp) {
                    if ($(this).is(':visible')) {
                        console.log('hide ' + temp);
                        $('#' + temp).collapse('hide');
                    }
                }
            });
    }
});
